(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["design-product"]) return;
  try {
    
  class DesignProductMultiForm extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('[data-design-form]');
      this.addButton = this.querySelector('[data-design-add]');
      this.subtotalElement = this.querySelector('[data-design-subtotal]');
      this.errorElement = this.querySelector('[data-design-error]');
      this.isSubmitting = false;

      if (!this.form || !this.addButton) return;

      this.addEventListener('click', this.handleClick);
      this.addEventListener('input', this.handleInput);
      this.form.addEventListener('submit', this.handleSubmit);
      this.syncButton();
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
      this.removeEventListener('input', this.handleInput);
      this.form?.removeEventListener('submit', this.handleSubmit);
    }

    handleClick = (event) => {
      if (!(event.target instanceof Element)) return;

      const minus = event.target.closest('[data-design-quantity-minus]');
      const plus = event.target.closest('[data-design-quantity-plus]');

      if (!minus && !plus) return;

      const row = event.target.closest('[data-design-variant-row]');
      const input = row?.querySelector('[data-design-quantity]');

      if (!(input instanceof HTMLInputElement) || input.disabled) return;

      const current = Math.max(0, Number.parseInt(input.value, 10) || 0);
      input.value = String(Math.max(0, current + (plus ? 1 : -1)));
      this.syncButton();
    };

    handleInput = (event) => {
      if (!(event.target instanceof HTMLInputElement)) return;
      if (!event.target.matches('[data-design-quantity]')) return;

      const value = Number.parseInt(event.target.value, 10);
      if (Number.isFinite(value) && value < 0) {
        event.target.value = '0';
      }

      this.syncButton();
    };

    collectItems() {
      const items = [];

      for (const row of this.querySelectorAll('[data-design-variant-row]')) {
        const input = row.querySelector('[data-design-quantity]');
        if (!(input instanceof HTMLInputElement) || input.disabled) continue;

        const quantity = Math.max(0, Number.parseInt(input.value, 10) || 0);
        const id = Number(row.dataset.variantId);

        if (quantity > 0 && Number.isSafeInteger(id)) {
          items.push({ id, quantity });
        }
      }

      return items;
    }

    syncButton() {
      if (!this.addButton) return;
      this.addButton.disabled = this.isSubmitting || this.collectItems().length === 0;
      this.syncSubtotal();
    }

    syncSubtotal() {
      if (!this.subtotalElement) return;

      let subtotalCents = 0;

      for (const row of this.querySelectorAll('[data-design-variant-row]')) {
        const input = row.querySelector('[data-design-quantity]');
        if (!(input instanceof HTMLInputElement) || input.disabled) continue;

        const quantity = Math.max(0, Number.parseInt(input.value, 10) || 0);
        const priceCents = Math.max(0, Number.parseInt(row.dataset.priceCents, 10) || 0);
        subtotalCents += quantity * priceCents;
      }

      const currency = window.Shopify?.currency?.active || 'USD';

      try {
        this.subtotalElement.textContent = new Intl.NumberFormat(
          document.documentElement.lang || undefined,
          {
            style: 'currency',
            currency,
          }
        ).format(subtotalCents / 100);
      } catch {
        this.subtotalElement.textContent = (subtotalCents / 100).toFixed(2);
      }
    }

    handleSubmit = async (event) => {
      event.preventDefault();

      const items = this.collectItems();
      if (items.length === 0 || this.isSubmitting) return;

      this.isSubmitting = true;
      this.syncButton();

      if (this.errorElement) {
        this.errorElement.hidden = true;
        this.errorElement.textContent = '';
      }

      const root = window.Shopify?.routes?.root || '/';

      try {
        const response = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({ items }),
        });

        const data = await response.json();

        if (!response.ok || data.status) {
          throw new Error(data.description || data.message || 'Unable to add items to cart.');
        }

        window.location.assign(`${root}cart`);
      } catch (error) {
        if (this.errorElement) {
          this.errorElement.textContent =
            error instanceof Error ? error.message : String(error);
          this.errorElement.hidden = false;
        }

        this.isSubmitting = false;
        this.syncButton();
      }
    };
  }

  if (!customElements.get('design-product-multi-form')) {
    customElements.define('design-product-multi-form', DesignProductMultiForm);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
